import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Stack, TextField, Tooltip, useMediaQuery } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import DescriptionIcon from '@mui/icons-material/Description';
export default function CardInvoice(props) {
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <Card sx={{ display: 'flex', margin: 2, justifyContent: matchDownMd ? 'center' : 'left' }} elevation={3}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Stack direction={matchDownMd ? 'column' : 'row'} alignItems="center">
                    {props.Head}
                    <CardContent sx={{ flex: '1 0 auto', maxWidth: 500 }}>
                        {/* <Typography component="div" variant="h5">
                        Live From Space
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary" component="div">
                        Mac Miller
                    </Typography> */}
                        {props.Body}
                    </CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'right', pl: 1, pb: 1 }}>
                        <Stack direction={matchDownSM ? 'row' : 'column'} spacing={5} alignItems="right">
                            <Tooltip title="">
                                <IconButton
                                    size="large"
                                    onClick={props.OnClickView}
                                    sx={{ marginLeft: matchDownSM ? 2 : 0, color: '#0c4da2' }}
                                >
                                    <VisibilityIcon />
                                </IconButton>
                            </Tooltip>
                            {props.BtnInvoice && (
                                <IconButton size="large" color="info" onClick={props.OnClickViewInvoice}>
                                    <DescriptionIcon />
                                </IconButton>
                            )}
                        </Stack>
                    </Box>
                </Stack>
            </Box>
        </Card>
    );
}
